import V2sContext from "contexts/V2sContext";
import { useContext } from "react";

const useV2s = () => useContext(V2sContext);

export default useV2s;
